import React from "react";
import LoginPage from "~/presentation/views/Login/LoginPage";

export const makeLoginPage = (params) => {
    return (
        <LoginPage
            {...params}
        />
    );
};
